// Copyright (c) Hamilton Manufacturing Corp.

import React from 'react';
import { Navigate } from "react-router-dom";

const Protected = ({ test, to = '/', children }) => {
    if (!test) {
        return <Navigate to={to} replace />;
    }
    return children;
};

export default Protected;
